function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
  }
}

// Cart Remove Button Custom Element
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const lineIndex = this.getAttribute('data-index');
      if (!lineIndex) return;

      // Remove item by setting quantity to 0
      this.updateCart(lineIndex, 0);
    });
  }

  updateCart(lineIndex, quantity) {
    this.showLoading();

    // Use cart/change.js for single line updates
    const body = JSON.stringify({
      line: parseInt(lineIndex),
      quantity: quantity
    });

    console.log('Removing cart item:', { line: parseInt(lineIndex), quantity: quantity });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Cart remove successful:', data);
      // Update cart counter before reload
      const itemCount = data.items_count || data.item_count;
      if (itemCount !== undefined && window.updateCartCount) {
        window.updateCartCount(itemCount);
      }
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      this.showError('Sorry, there was an issue updating your cart.');
    })
    .finally(() => {
      this.hideLoading();
    });
  }

  showLoading() {
    const button = this.querySelector('button');
    if (button) {
      button.disabled = true;
      button.style.opacity = '0.5';
    }
  }

  hideLoading() {
    const button = this.querySelector('button');
    if (button) {
      button.disabled = false;
      button.style.opacity = '1';
    }
  }

  showError(message) {
    // You can implement error display logic here
    alert(message);
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

// Global cart counter update function
function updateCartCount(count) {
  // Validate and sanitize the count
  const validCount = (count !== undefined && count !== null) ? parseInt(count) : 0;
  console.log('Updating cart count to:', validCount, '(original value:', count, ')');

  // Update mobile cart count
  const mobileCartCounts = document.querySelectorAll('.cart-count');
  mobileCartCounts.forEach(el => {
    el.textContent = validCount;
  });

  // Update desktop cart count (which is text content in the desktop div)
  const desktopCartLinks = document.querySelectorAll('.nav-list__cart .desktop');
  desktopCartLinks.forEach(el => {
    // Extract the text and replace the count in parentheses
    const cartText = el.textContent.replace(/\(\d+\)/, `(${validCount})`);
    el.textContent = cartText;
  });
}

// Make updateCartCount available globally
window.updateCartCount = updateCartCount;

// Initialize cart counter on page load and when product options change
document.addEventListener('DOMContentLoaded', function() {
  console.log('=== CART DEBUG INFO ===');

  // Function to refresh cart counter from server
  function refreshCartCounter() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {
        console.log('Current cart structure:', cartData);
        console.log('Current cart properties:', Object.keys(cartData));
        console.log('Current item_count:', cartData.item_count);
        console.log('Current items_count:', cartData.items_count);
        console.log('Current total_quantity:', cartData.total_quantity);
        console.log('Current quantity:', cartData.quantity);

        // Update cart counter with actual current count
        const currentCount = cartData.item_count || cartData.items_count || cartData.total_quantity || 0;
        if (window.updateCartCount) {
          window.updateCartCount(currentCount);
        }
      })
      .catch(err => console.error('Error fetching cart debug info:', err));
  }

  // Initial cart counter refresh
  refreshCartCounter();

      // Listen for product option changes (radio buttons, selects, etc.)
  document.addEventListener('change', function(event) {
    // If it's a product form input that might change variants/selling plans
    if (event.target.matches('input[type="radio"]') ||
        event.target.matches('select') ||
        event.target.matches('input[name*="selling_plan"]') ||
        event.target.matches('input[name*="id"]') ||
        event.target.closest('.product-form') ||
        event.target.closest('product-form')) {

      console.log('Product option changed:', event.target.name || event.target.className, 'refreshing cart counter...');
      // Use debounced refresh to prevent competing updates
      if (window.debouncedRefreshCartCounter) {
        window.debouncedRefreshCartCounter();
      } else {
        setTimeout(refreshCartCounter, 300);
      }
    }
  });

    // Also listen for clicks on radio buttons specifically (in case change event doesn't fire)
  document.addEventListener('click', function(event) {
    if (event.target.matches('input[type="radio"]') &&
        (event.target.closest('.product-form') || event.target.closest('product-form'))) {
      console.log('Radio button clicked, refreshing cart counter...');
      if (window.debouncedRefreshCartCounter) {
        window.debouncedRefreshCartCounter();
      } else {
        setTimeout(refreshCartCounter, 500);
      }
    }
  });

  // Prevent multiple rapid updates
  let refreshTimeout;
  const debouncedRefresh = function() {
    clearTimeout(refreshTimeout);
    refreshTimeout = setTimeout(refreshCartCounter, 400);
  };

  // Override the global refresh to use debounced version
  window.debouncedRefreshCartCounter = debouncedRefresh;

  // Make refreshCartCounter available globally
  window.refreshCartCounter = refreshCartCounter;
});

// Cart functionality for cart page
    document.addEventListener('DOMContentLoaded', function () {
  const cartForm = document.querySelector('form#cart');

  if (!cartForm) return;

  // Update cart when quantity changes
  cartForm.addEventListener('change', (event) => {
    if (event.target.matches('input[name="updates[]"]')) {
      const input = event.target;
      const lineIndex = input.getAttribute('data-index');
      const quantity = parseInt(input.value) || 0;

      // Clear any existing timer for this specific input
      clearTimeout(input.updateTimer);

      // Delay the update slightly to allow for multiple quick changes
      input.updateTimer = setTimeout(() => {
        updateSingleCartLine(lineIndex, quantity, input);
      }, 300);
    }
  });

  function updateSingleCartLine(lineIndex, quantity, inputElement) {
    // Show loading state for this specific item
    const cartItem = inputElement.closest('.cart-item');
    const loadingOverlay = cartItem?.querySelector('.loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.classList.remove('hidden');
    }

    // Use cart/change.js for single line updates - more reliable
    const body = JSON.stringify({
      line: parseInt(lineIndex),
      quantity: quantity
    });

    console.log('Updating cart line:', { line: parseInt(lineIndex), quantity: quantity });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Cart update successful:', data);
      // Update cart counter before reload
      const itemCount = data.items_count || data.item_count;
      if (itemCount !== undefined && window.updateCartCount) {
        window.updateCartCount(itemCount);
      }
      // Update was successful, reload to show updated cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      showCartError('Sorry, there was an issue updating your cart.');
      // Revert the input value if there's an error
      inputElement.value = inputElement.defaultValue;
    })
    .finally(() => {
      // Hide loading state
      if (loadingOverlay) {
        loadingOverlay.classList.add('hidden');
      }
    });
  }

  function showCartLoading() {
    cartForm.querySelectorAll('.loading-overlay').forEach(overlay => {
      overlay.classList.remove('hidden');
    });
  }

  function hideCartLoading() {
    cartForm.querySelectorAll('.loading-overlay').forEach(overlay => {
      overlay.classList.add('hidden');
    });
  }

  function showCartError(message) {
    const errorContainer = document.getElementById('cart-errors');
    if (errorContainer) {
      errorContainer.innerHTML = `<div class="alert alert-error">${message}</div>`;
    } else {
      alert(message);
    }
  }
});

// Cart drawer functionality
document.addEventListener('DOMContentLoaded', function () {
  const cartDrawerForm = document.querySelector('form#CartDrawer-Form');

  if (!cartDrawerForm) return;

  // Update cart when quantity changes in cart drawer
  cartDrawerForm.addEventListener('change', (event) => {
    if (event.target.matches('input[name="updates[]"]')) {
      const input = event.target;
      const lineIndex = input.getAttribute('data-index');
      const quantity = parseInt(input.value) || 0;

      // Clear any existing timer for this specific input
      clearTimeout(input.updateTimer);

      // Delay the update slightly to allow for multiple quick changes
      input.updateTimer = setTimeout(() => {
        updateSingleCartDrawerLine(lineIndex, quantity, input);
      }, 300);
    }
  });

  function updateSingleCartDrawerLine(lineIndex, quantity, inputElement) {
    // Show loading state for this specific item
    const cartItem = inputElement.closest('.cart-item');
    const loadingOverlay = cartItem?.querySelector('.loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.classList.remove('hidden');
    }

    // Use cart/change.js for single line updates - more reliable
    const body = JSON.stringify({
      line: parseInt(lineIndex),
      quantity: quantity
    });

    console.log('Updating cart drawer line:', { line: parseInt(lineIndex), quantity: quantity });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
      .then(data => {
      console.log('Cart drawer update successful:', data);
      // Update cart counter before reload
      const itemCount = data.items_count || data.item_count;
      if (itemCount !== undefined && window.updateCartCount) {
        window.updateCartCount(itemCount);
      }
      // Update was successful, reload to show updated cart
        window.location.reload();
      })
    .catch(error => {
      console.error('Error updating cart drawer:', error);
      showCartDrawerError('Sorry, there was an issue updating your cart.');
      // Revert the input value if there's an error
      inputElement.value = inputElement.defaultValue;
    })
    .finally(() => {
      // Hide loading state
      if (loadingOverlay) {
        loadingOverlay.classList.add('hidden');
      }
    });
  }

  function showCartDrawerLoading() {
    cartDrawerForm.querySelectorAll('.loading-overlay').forEach(overlay => {
      overlay.classList.remove('hidden');
    });
  }

  function hideCartDrawerLoading() {
    cartDrawerForm.querySelectorAll('.loading-overlay').forEach(overlay => {
      overlay.classList.add('hidden');
    });
  }

  function showCartDrawerError(message) {
    const errorContainer = document.getElementById('CartDrawer-CartErrors');
    if (errorContainer) {
      errorContainer.innerHTML = `<div class="alert alert-error">${message}</div>`;
    } else {
      alert(message);
    }
  }
});
